import moment from 'moment';
import ModelProxy, {required, optional} from './proxy';


export default class RawRxHistory extends ModelProxy {

  static propTypes = {
    existingPatientId: optional,
    ptAlias: required,
    rawSequenceUuid: optional,
    startDateMatch: required,
    startDate: required,
    stopDateMatch: required,
    stopDate: required,
    orderUnknown: required,
    durationUnknown: required,
    drugs: required
  };

  static defaultProps = {
    startDateMatch: '<=',
    stopDateMatch: '=',
    orderUnknown: 'No',
    durationUnknown: 'Yes',
    drugs: ''
  };

  static setExistingPatientId(self, value) {
    if (typeof(value) === 'string' && !/^\d+$/.test(value)) {
      // process graphql's ID
      value = atob(value).replace(/^Patient:/, '');
    }
    if (value) {
      self.props.existingPatientId = parseInt(value);
    }
  }

  static getWeeks(self) {
    const {startDate, stopDate} = self.props;
    let weeks = Math.round(moment.duration(
      moment.utc(stopDate).diff(moment.utc(startDate))
    ).asWeeks());

    if (weeks === 0 && startDate != stopDate) {
      weeks = 1;
    }
    return weeks;
  }

  static setDrugs(self, value) {
    value = value.replace('/r', '+RTV');
    value = value.split(/[,+]/);
    value = value.map(d => d.trim()).filter(d => d);
    value = Array.from(new Set(value));
    self.props.drugs = value.join(',');
  }

  static validateStopDate(self, stopDate) {
    const msgs = [];
    const {startDate} = self.props;
    if (moment.utc(startDate).isSameOrAfter(moment.utc(stopDate))) {
      msgs.push({
        text: 'Property "stopDate" is earlier than "startDate".',
        level: 'error'
      });
    }
    return msgs;
  }
}



// WEBPACK FOOTER //
// ./src/models/raw-rx-history.js